import { authHeaderWithToken } from "./auth-header"
import configData from "config.json"
import { alertService } from "components/Varios/alert_service"
import axios, { AxiosError } from "axios";
import { authenticationService } from "services/authentication.service";

const URL_VISTA_PREVIA_FILES = "Files/GetArchivoVistaPrevia/refArchivo/"
export const URL_DOWNLOAD_FILES = "Files/GetFile/refArchivo/"

function HandleErrorDocument(status_code:number){
    
    switch (status_code) {
        case 0:
            alertService.error("No se ha podido establecer contacto con el servidor");
            break;
        case 500:
            alertService.error("Ha ocurrido un error inesperado");
            break;
        default:
            alertService.error("Ha ocurrido un error desconocido");
            break;
    }
    window.scrollTo({
        top: 0,
        behavior: "auto"
    });
}

function HandleErrorResponse(response:Response){
    HandleErrorDocument(response.status);
}

export async function GetDocumentVistaPrevia(refFile: string, token: string) {
    let urlArchivoVistaPrevia ="";
    var url_completa = `${URL_VISTA_PREVIA_FILES + refFile}`
    const respuesta = await fetch(configData.SERVER_URL + url_completa, {
        method: 'GET',
        headers: authHeaderWithToken(token),
        
    })
    if(respuesta.ok){       
        const archivo = await respuesta.blob()
            .then( archivo => {
                urlArchivoVistaPrevia = window.URL.createObjectURL(archivo);
                // var file_object = new File([archivo], "certificado");
            });
        
    }
    else{
        HandleErrorResponse(respuesta);
    }

    return urlArchivoVistaPrevia;                        
    
}

export async function GetDocumentVistaPrevia2(refFile: string) {
    let urlArchivoVistaPrevia ="";
    const token = authenticationService.currentUserValue.token;
    var url_completa = `${URL_VISTA_PREVIA_FILES + refFile}`
    const respuesta = await fetch(configData.SERVER_URL + url_completa, {
        method: 'GET',
        headers: authHeaderWithToken(token),
        
    })
    if(respuesta.ok){       
        const archivo = await respuesta.blob()
            .then( archivo => {
                urlArchivoVistaPrevia = window.URL.createObjectURL(archivo);
                // var file_object = new File([archivo], "certificado");
            });
        
    }
    else{
        HandleErrorResponse(respuesta);
    }

    return urlArchivoVistaPrevia;                        
    
}

export async function DownloadDocument(refFile: string, token: string,nombreArchivo?:string){
    var urlarchivo = await GetDocumentVistaPrevia(refFile,token);
    if(urlarchivo){
        let a = document.createElement('a');
        a.href = urlarchivo;
        a.download = nombreArchivo??"hoja de vida.pdf";
        a.click();

        
    }
}

export async function DownloadDocument2(refFile: string,nombreArchivo?:string){
    const token = authenticationService.currentUserValue.token;
    var urlarchivo = await GetDocumentVistaPrevia(refFile,token);
    if(urlarchivo){
        let a = document.createElement('a');
        a.href = urlarchivo;
        a.download = nombreArchivo??"hoja de vida.pdf";
        a.click();

        
    }
}



export async function DownloadDocumentWithAPI(urlAPI:string,token:string,nombreArchivo?:string){
    let urlArchivo ="";
    
    try {
        const respuesta = await axios.get(urlAPI, {
            headers:authHeaderWithToken(token),
            responseType:"blob"
        })

        if(respuesta.status === 200){
            const archivo = respuesta.data;
            urlArchivo = window.URL.createObjectURL(archivo);
            
        }

    } catch (error) {
        const mensajeErrorDefault = "Ha ocurrido un inconveniente con la descarga del archivo";
        if(axios.isAxiosError(error)){
            const axiosError = error as AxiosError<Blob>;
            if (axiosError.response && (axiosError.response.status === 409)) {
                // Convertir el blob a texto
                const textoPlano = await axiosError.response.data.text();
                alertService.error(textoPlano);

            } else{
                alertService.error(mensajeErrorDefault);
            }
        }
        else {
            alertService.error("Ha ocurrido un inconveniente con la descarga del archivo");
        }
        
    }

    const defaultName = `${new Date().getUTCMilliseconds().toString()}.pdf`

    if(urlArchivo){
        // let a = document.createElement('a');
        // a.href = urlArchivo;
        // a.download = nombreArchivo??defaultName
        // a.click();
        window.open(urlArchivo, '_blank');
    }
}
export async function GetDownloadDocument(refFile: string, token: string, nombreArchivo?: string) {
    var urlarchivo = await GetDocumentVistaPrevia(refFile, token);
    if (urlarchivo) {
        let a = document.createElement('a');
        a.href = urlarchivo;
        if (nombreArchivo !== undefined && nombreArchivo.includes(".pdf")) {
            a.download = nombreArchivo
        }
        else if (nombreArchivo !== undefined && !nombreArchivo.includes(".pdf")) {
            a.download = nombreArchivo + ".pdf"
        }
        else {
            a.download = nombreArchivo ?? "hoja de vida.pdf";
        }
        a.click();
    }
}